import { isolateComponent } from '@zapier/style-encapsulation';
import { Alert, Link } from '@zapier/design-system';
const calculateAnnualSavingsAmount = (data) => {
    var _a;
    const { currentAccount } = data;
    const currentPlan = currentAccount.plan;
    const alternatePlan = (_a = data.possiblePlans
        .find((possiblePlan) => {
        return possiblePlan.planType === currentPlan.type;
    })) === null || _a === void 0 ? void 0 : _a.plans.find((plan) => {
        return plan.name === currentPlan.name && plan.interval === 'year';
    });
    const currentMonthlyAmount = currentPlan.amount || 0;
    const alternateMonthlyAmount = ((alternatePlan === null || alternatePlan === void 0 ? void 0 : alternatePlan.amount) || currentMonthlyAmount) / 12;
    const difference = currentMonthlyAmount - alternateMonthlyAmount;
    return difference / currentMonthlyAmount;
};
export const shouldRender = (data) => {
    const { currentAccount } = data;
    const currentPlan = currentAccount.plan;
    if (currentPlan.interval === 'year' || !currentPlan.isInPlanGroup) {
        return false;
    }
    return calculateAnnualSavingsAmount(data) > 0;
};
export const Component = function AnnualBillingUpsell(props) {
    const { data } = props;
    const currentPlan = data.currentAccount.plan;
    const savingsAmount = calculateAnnualSavingsAmount(data);
    const savingsPercent = `${Math.floor(savingsAmount * 100)}%`;
    const upgradeUrl = encodeURI(`/app/billing/plans/change/${currentPlan.name.toLowerCase()}`);
    const onUpgrade = () => {
        props.trackEvent('clicked annual billing nudge');
    };
    const title = (isolateComponent("span", null,
        `Save ${savingsPercent} when you `,
        isolateComponent(Link, { href: upgradeUrl, onClick: onUpgrade }, "switch to an annual subscription")));
    return isolateComponent(Alert, { layout: props.layout, title: title, type: "info" });
};
//# sourceMappingURL=AnnualBillingUpsell.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
